module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0005.jpg?v=d81da84f";